import React from 'react';
import PropTypes from 'prop-types';
// Only global rules are left in this file; importing it keeps their place in the cascade
import './AddProjectModal.module.css';
import ProjectFormModal from './projectForm/ProjectFormModal';

/** "Yeni Proje Ekle" (Tailwind form shared with "Proje Düzenle"). */
const AddProjectModal = ({ onClose, onUpdate }) => <ProjectFormModal onClose={onClose} onSaved={onUpdate} />;

AddProjectModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default AddProjectModal;
